import { gql, useMutation } from '@apollo/client';
import * as React from 'react';

import type { UpdateCalloutMutation, UpdateCalloutMutationVariables } from './__generated__/useUpdateCallout.gql';

const UPDATE_CALLOUT = gql`
  mutation UpdateCallout($id: ID!, $input: CalloutUpdateInputGQL!) {
    updateCallout(id: $id, input: $input) {
      id
      dismissed
      appropriate
      transaction {
        id
      }
    }
  }
`;

interface IDismissCalloutOptions {
  calloutId: string;
  appropriate?: boolean;
}

/**
 * Hook for updating callouts.
 * Provides a dismissCallout helper for convenience.
 *
 * Note: All cache updates for this mutation are handled globally in ApolloProvider.tsx
 */
export const useUpdateCallout = () => {
  const [updateCallout, result] = useMutation<UpdateCalloutMutation, UpdateCalloutMutationVariables>(UPDATE_CALLOUT);

  const dismissCallout = React.useCallback(
    async ({ calloutId, appropriate }: IDismissCalloutOptions) => {
      await updateCallout({
        variables: {
          id: calloutId,
          input: {
            dismissed: true,
            ...(appropriate !== undefined && { appropriate }),
          },
        },
      });
    },
    [updateCallout]
  );

  return { updateCallout, dismissCallout, ...result };
};
